import { NavLink } from "react-router-dom";
import { PathName } from "../../../constants/PathName";

export const FormBuilderTabs = () => {
	return (
		<div className="formBuilder-tabs">
			<NavLink
				to={PathName.FORM_BUILDER_FORMS}
				className="formBuilder-tab"
				activeClassName="formBuilder-tab--active"
			>
				Forms
			</NavLink>
			<NavLink
				to={PathName.FORM_BUILDER_SELECTS}
				className="formBuilder-tab"
				activeClassName="formBuilder-tab--active"
			>
				Selects
			</NavLink>
		</div>
	);
};
